module.exports = __webpack_public_path__ + "static/withoutcuttriangle-4fe40420ee02c6b885fc8b1787837754.gif";